export default {
  req_loading: "載入中...",
  req_error: "網路逾時,請稍後再試"
}